import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import FunnelView from '../../containers/funnel/View';
import FunnelSideListItems from '../../containers/funnel/side/ListItems';
import FunnelSideListAddButton from '../../containers/funnel/side/ListAddButton';
import FunnelUpdatePaneContainer from './update/PaneContainer';
import FunnelExecutionPaneContainer from './execution/PaneContainer';
import NavigationBar from '../navigation/NavigationBar';
import { scrollToActiveElement } from '../../utils/compound';

const FunnelContainer = ({
  tenantId,
  isFunnelsTabOpen,
  selectedFunnel,
  onExecute,
  executeDisabled,
  executing,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isFunnelsTabOpen) {
      navigate(`/${tenantId}/funnels/execution/${selectedFunnel.id}`);
      setTimeout(
        () => scrollToActiveElement({ block: 'nearest', inline: 'nearest', behavior: 'instant' }),
        0
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFunnelsTabOpen]);

  return (
    <>
      <NavigationBar onExecute={onExecute} executeDisabled={executeDisabled || executing} />
      <FunnelView>
        <FunnelSideListItems tenantId={tenantId} navigate={navigate}>
          <FunnelSideListAddButton tenantId={tenantId} />
        </FunnelSideListItems>
        <Routes>
          <Route path="/add" element={<FunnelUpdatePaneContainer navigate={navigate} />} />
          <Route path="/update/:id" element={<FunnelUpdatePaneContainer navigate={navigate} />} />
          <Route
            path="/execution/:id"
            element={<FunnelExecutionPaneContainer tenantId={tenantId} />}
          />
        </Routes>
      </FunnelView>
    </>
  );
};

export default FunnelContainer;
